"use client";

import { useCart } from "@/hooks/cart/use-cart";
import { CartLink } from "./cart-link";

export function CartIconButton() {
 const { itemCount } = useCart();
 return <CartLink itemCount={itemCount} />;
}
